export default function CTASection() {
  return (
    <section className="relative flex flex-col lg:flex-row min-h-[500px] md:min-h-[600px]">
      <div className="lg:w-1/2 relative min-h-[300px] lg:min-h-full">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20and%20inviting%20online%20shopping%20concept%20with%20a%20laptop%20displaying%20an%20ecommerce%20store%20surrounded%20by%20carefully%20arranged%20shopping%20bags%20and%20fashion%20items%20on%20a%20cozy%20wooden%20desk%2C%20golden%20hour%20sunlight%2C%20lifestyle%20photography%20with%20authentic%20homey%20feel&width=1200&height=900&seq=cta-store-v3&orientation=landscape"
          alt="Litbuy Spreadsheet products"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute top-6 left-6 md:top-8 md:left-8">
          <span className="inline-block px-4 py-1.5 rounded-full bg-white/80 backdrop-blur-sm text-foreground-800 text-xs md:text-sm font-medium">
            (Official Store)
          </span>
        </div>
        <div className="absolute bottom-6 left-6 md:bottom-10 md:left-10">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight drop-shadow-lg">
            Get
            <br />
            Litbuy
            <br />
            Spreadsheet Now
          </h2>
        </div>
      </div>

      <div className="lg:w-1/2 bg-background-50 flex flex-col items-center justify-center px-6 md:px-10 py-12 md:py-16">
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 text-center leading-tight">
          Visit Our
          <br />
          Main Store
        </h2>
        <p className="mt-6 md:mt-8 text-sm md:text-base text-foreground-600 text-center max-w-md leading-relaxed">
          Discover the full collection of premium spreadsheet tools and templates at kaspreadsheet.com. 
          From inventory management to sales tracking, our main store has everything you need to run a successful e-commerce business.
        </p>
        <a
          href="https://kaspreadsheet.com/"
          target="_blank"
          rel="noopener nofollow"
          className="whitespace-nowrap cursor-pointer mt-8 md:mt-10 inline-flex items-center gap-2 px-8 py-4 rounded-full bg-primary-500 text-white font-semibold text-sm md:text-base hover:bg-primary-600 transition-all duration-300 hover:scale-105"
        >
          Litbuy Spreadsheet
          <i className="ri-arrow-right-line"></i>
        </a>
      </div>
    </section>
  );
}